<div
    [ngClass]="{
        'header__not-description': !headerData.description,
        header: !!headerData.description,
    }"
    *ngIf="headerData"
>
    <img *ngIf="!!headerData.iconUrl" class="header__image" [src]="headerData.iconUrl" alt="Icon" />
    <h1>{{ headerData.title }}</h1>
    <h2>{{ headerData.subtitle }}</h2>
    <p *ngIf="!!headerData.description">{{ headerData.description }}</p>
</div>
